import service from "@/utils/request";

// 商品列表
interface getProductListI {
  page?: number;
  page_size?: number;
  title?: string;
  category_id?: number;
}
export const getProductListApi = (params: getProductListI) => {
  return service({
    url: "/api/v1/product/list",
    method: "get",
    params,
  });
};
// 添加商品
interface createProductI {
  title: string;
  category_id: number;
}
export const createProductApi = (data: createProductI) => {
  return service({
    url: "/api/v1/product/create",
    method: "post",
    data,
  });
};
// 编辑商品
interface editProductI {
  product_id: number;
  title: string;
  category_id: number;
}
export const editProductApi = (data: editProductI) => {
  return service({
    url: "/api/v1/product/edit",
    method: "post",
    data,
  });
};
// 删除商品
interface deleteProductI {
  product_id: number;
  title: string;
  category_id: number;
}
export const deleteProductApi = (data: deleteProductI) => {
  return service({
    url: "/api/v1/product/delete",
    method: "post",
    data,
  });
};
